import { proxy } from 'valtio';
import { subscribeKey } from 'valtio/utils';

import { RequestStatus } from '@paid-ui/enums/request';

import { contractManager } from './contract';

export interface AccessLinkedContractsRequest {
  id: string;
  requestStatus: RequestStatus;
  latestSnapshotVersion: number;
  reasonForRejection?: string;
  notes?: string;
  reviewer: {
    id: string;
    displayName: string;
  };
  submitter: {
    id: string;
    displayName: string;
  };
  createdBy: {
    id: string;
    name: string;
    email: string;
    groupId: string;
  };
}

export const accessLinkedContractsRequestManager = proxy({
  data: [] as AccessLinkedContractsRequest[],
  pendingAccessRequest: null as AccessLinkedContractsRequest | null,
});

export const saveAccessLinkedContractsRequests = (data: AccessLinkedContractsRequest[]) => {
  accessLinkedContractsRequestManager.data = data;
};

export const resetAccessLinkedContractsRequests = () => {
  accessLinkedContractsRequestManager.data = [];
  accessLinkedContractsRequestManager.pendingAccessRequest = null;
};

subscribeKey(accessLinkedContractsRequestManager, 'data', (requests) => {
  const { currentParty, permissions } = contractManager;

  const pendingAccessRequest = requests.find(
    (request) =>
      request.requestStatus === RequestStatus.SUBMITTED &&
      request.createdBy.groupId === currentParty?.userGroup?.id,
  );

  accessLinkedContractsRequestManager.pendingAccessRequest = pendingAccessRequest ?? null;
  contractManager.permissions.canRequestLinkedContractsAccess =
    permissions.canRequestLinkedContractsAccess && !pendingAccessRequest;
});
